import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", { class: "icon button__icon stroke-2" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#close-small" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "creationV2__content" }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center fixed inset-0 m-8 text-center"
}
const _hoisted_5 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveyHeaderComponent = _resolveComponent("SurveyHeaderComponent")!
  const _component_SurveyInactiveView = _resolveComponent("SurveyInactiveView")!
  const _component_SurveyVideoView = _resolveComponent("SurveyVideoView")!
  const _component_SurveyNPSView = _resolveComponent("SurveyNPSView")!
  const _component_SurveyCSATView = _resolveComponent("SurveyCSATView")!
  const _component_SurveyAgentView = _resolveComponent("SurveyAgentView")!
  const _component_SurveyDetailsView = _resolveComponent("SurveyDetailsView")!
  const _component_SurveyLoaderView = _resolveComponent("SurveyLoaderView")!
  const _component_SurveyFinishView = _resolveComponent("SurveyFinishView")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_LegacyRecorderView = _resolveComponent("LegacyRecorderView")!

  return (_ctx.campaign && _ctx.campaign.newRecorder)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["creationV2", {'creationV2--background': _ctx.showBackgroundImage}])
      }, [
        (_ctx.inAppPresentation)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.sdkClose()), ["prevent"])),
              class: "button button--circle-creation-primary fixed top-4 right-4 z-50 !p-0 w-10 h-10"
            }, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SurveyHeaderComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"]),
          (_ctx.isInactiveState)
            ? (_openBlock(), _createBlock(_component_SurveyInactiveView, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isVideoState)
            ? (_openBlock(), _createBlock(_component_SurveyVideoView, {
                key: 1,
                campaign: _ctx.campaign,
                onFinished: _ctx.onVideoFinished
              }, null, 8, ["campaign", "onFinished"]))
            : (_ctx.isNPSState)
              ? (_openBlock(), _createBlock(_component_SurveyNPSView, {
                  key: 2,
                  campaign: _ctx.campaign,
                  initialQuestion: _ctx.NPSQuestion,
                  onFinished: _ctx.onNPSRatingSubmitted
                }, null, 8, ["campaign", "initialQuestion", "onFinished"]))
              : (_ctx.isCSATState)
                ? (_openBlock(), _createBlock(_component_SurveyCSATView, {
                    key: 3,
                    campaign: _ctx.campaign,
                    initialQuestion: _ctx.CSATQuestion,
                    onFinished: _ctx.onCSATRatingSubmitted
                  }, null, 8, ["campaign", "initialQuestion", "onFinished"]))
                : (_ctx.isInitialState)
                  ? (_openBlock(), _createBlock(_component_SurveyAgentView, {
                      key: 4,
                      campaign: _ctx.campaign,
                      initialQuestion: _ctx.promptQuestion,
                      combinedSurveyQuestion: _ctx.combinedSurveyQuestion,
                      rating: _ctx.rating,
                      onFinished: _ctx.onSurveyFinished
                    }, null, 8, ["campaign", "initialQuestion", "combinedSurveyQuestion", "rating", "onFinished"]))
                  : (_ctx.isDetailsState)
                    ? (_openBlock(), _createBlock(_component_SurveyDetailsView, {
                        key: 5,
                        campaign: _ctx.campaign,
                        isPreview: _ctx.isPreview,
                        onFinished: _ctx.onSurveyDetailsFinished
                      }, null, 8, ["campaign", "isPreview", "onFinished"]))
                    : (_ctx.isLoadingState)
                      ? (_openBlock(), _createBlock(_component_SurveyLoaderView, {
                          key: 6,
                          isError: !!_ctx.error,
                          message: _ctx.loaderMessage,
                          onTryAgainClicked: _ctx.tryAgainClicked
                        }, null, 8, ["isError", "message", "onTryAgainClicked"]))
                      : (_ctx.isFinishedState)
                        ? (_openBlock(), _createBlock(_component_SurveyFinishView, {
                            key: 7,
                            campaign: _ctx.campaign
                          }, null, 8, ["campaign"]))
                        : _createCommentVNode("", true),
          _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
        ]),
        (_ctx.showBackgroundImage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["creationV2__image", { 'creationV2__image--blurred': _ctx.isDetailsState }]),
              style: _normalizeStyle({backgroundImage: `url(${_ctx.backgroundImageURL})`})
            }, null, 6))
          : _createCommentVNode("", true)
      ], 2))
    : (_ctx.fetchError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("survey.generalError")), 1)
        ]))
      : (_ctx.campaign && !_ctx.campaign.newRecorder)
        ? (_openBlock(), _createBlock(_component_LegacyRecorderView, {
            key: 2,
            campaign: _ctx.campaign,
            isPreview: _ctx.isPreview,
            previewState: _ctx.oldPreviewState
          }, null, 8, ["campaign", "isPreview", "previewState"]))
        : _createCommentVNode("", true)
}